(function ($, Global) {
    function BannerLancementLaLettreComponent() {
        // Déclaration class objet
    }

    BannerLancementLaLettreComponent.prototype.initEvents = function () {
        this.publishers();
    }

    BannerLancementLaLettreComponent.prototype.publishers = function () {
        $(document).on('click', '.banner-lalettre-formule .btn-close', function () {
            Global.Cookie.create('_POPLANC', 'yes', 365);
            $(this).closest('.banner-lalettre-formule').hide();
        });
    }

    Global.BannerLancementLaLettreComponent = BannerLancementLaLettreComponent;
}(jQuery, window));